import { Button } from '@sunwebgroup/uds-ui/button'
import * as React from 'react'
import styles from './CollapseByHeight.module.css'

interface CollapseByHeightProps {
  closeText: string
  openText: string
  height: string
  onClick: (result: string) => void
}

export function CollapseByHeight({
  closeText,
  openText,
  height,
  onClick,
  children,
}: React.PropsWithChildren<CollapseByHeightProps>) {
  const [isOpen, setIsOpen] = React.useState(false)
  const [currentHeight, setCurrentHeight] = React.useState(height)

  const handleOnToggle = () => {
    setIsOpen(!isOpen)
    if (isOpen) {
      setCurrentHeight(height)
      onClick('Show less')
    }
    else {
      setCurrentHeight('100%')
      onClick('Show more')
    }
  }

  return (
    <>
      <div className={styles.wrapper} style={{ '--_height': currentHeight } as React.CSSProperties}>{children}</div>
      <Button className={styles.trigger} variant="transparentPrimary" onClick={handleOnToggle}>
        {isOpen ? openText : closeText}
        <Button.Icon glyph={isOpen ? 'ChevronUpExtraSmall' : 'ChevronDownExtraSmall'} />
      </Button>
    </>
  )
}
